import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormStack from 'components/FormStack';
import FormField from 'components/FormField';
import TextInput from 'components/TextInput';
import TextArea from 'components/TextArea';
import CheckboxOption from 'components/CheckboxOption';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function CollapsableMessageForm(_ref) {
  var subject = _ref.subject,
    message = _ref.message,
    handleSubmit = _ref.handleSubmit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showForm = _useState2[0],
    setShowForm = _useState2[1];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CheckboxOption, {
      fontSize: "s",
      id: "showMessage",
      label: t('actions_add_personal_message'),
      checked: showForm,
      onChange: function onChange() {
        return setShowForm(!showForm);
      }
    }), showForm && /*#__PURE__*/_jsxs(FormStack, {
      mt: "s",
      children: [/*#__PURE__*/_jsx(FormField, {
        required: true,
        label: t('property_subject'),
        alert: subject.error,
        children: /*#__PURE__*/_jsx(TextInput, {
          value: subject.value,
          onChange: function onChange(e) {
            return subject.set(e.target.value);
          },
          onSubmit: handleSubmit
        })
      }), /*#__PURE__*/_jsx(FormField, {
        required: true,
        label: t('property_message'),
        alert: message.error,
        children: /*#__PURE__*/_jsx(TextArea, {
          maxRows: 8,
          value: message.value,
          onChange: function onChange(e) {
            return message.set(e.target.value);
          },
          onSubmit: handleSubmit
        })
      })]
    })]
  });
}
export default CollapsableMessageForm;